import React from 'react'
import Header from 'units/dashboard/components/Header'
import AdminSidebar from '../components/AdminSidebar'
import Footer from 'units/dashboard/components/Footer'
import PersonalPlanRequestTable from "./PersonalPlanRequestTable/PersonalPlanRequestTable"

export default function PersonalPlanRequest() {
    return (
        <>

            <nav
                className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
                <Header />
            </nav>

            <div
                className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
                <AdminSidebar />
            </div>

            <div className="flex flex-col min-h-screen">
                <div className="main-content flex-grow pt-16 ">
                    <div className="col-span-12  xl:col-span-6 xl:p-6  min-h-screen rtl items-center justify-center pb-5">

                        <div className="card-body pb-0 bg-white shadow-sm rounded-lg p-6">
                            <h4 className="mb-4 text-lg font-semibold text-gray-800 dark:text-gray-100">
                                فهرست درخواست طرح های اختصاصی
                            </h4>
                            <p className="text-gray-600 dark:text-gray-300 pb-4">
                                در این بخش می‌توانید درخواست طرح های اختصاصی را مشاهده کنید.
                            </p>
                        </div>
                        {/* <div className="max-w-[850px] m-auto flex justify-center items-center flex-wrap gap-2 gap-x-1 md:gap-x-8 mt-10 pr-2 ">

                            
                        </div> */}

                        <PersonalPlanRequestTable />


                    </div >
                    <Footer />
                </div>
            </div>
        </>
    )
}
